/**
 * The attention route table (design §5.9).
 *
 * `/attention` sits at the top level rather than under a module because it is
 * not one module's screen: it is the projection over approvals, exceptions,
 * tasks and alerts from all of them (XFN-NT-001). It is meant to be checked
 * daily, so filing it under Settings would bury it. It is NOT the role landing
 * (XFN-UX-013): `/` is the home screen, and the C16 fix round (DECISIONS.md
 * 2026-10-11 item 3, `docs/FSD_UI_EXTRANEOUS.md`) keeps XFN-UX-013 `partial`.
 *
 * The list route is gated on `attention.item.read`, which every role holds; the
 * policy editor is gated on `attention.policy.manage`, which is administrative.
 */

import type { RouteRecordRaw } from 'vue-router'

import { ATTENTION_PERMISSIONS } from '@/modules/attention/permissions'

export const ATTENTION_ROUTES: RouteRecordRaw[] = [
  {
    path: '/attention',
    name: 'attention',
    component: () => import('@/modules/attention/AttentionListView.vue'),
    meta: { titleKey: 'attention.routeTitles.list', permission: ATTENTION_PERMISSIONS.itemRead },
  },
  {
    path: '/settings/notification-policies',
    name: 'attention-policies',
    component: () => import('@/modules/attention/NotificationPolicyView.vue'),
    meta: {
      titleKey: 'attention.routeTitles.policies',
      permission: ATTENTION_PERMISSIONS.policyManage,
    },
  },
]
